import React, { useState } from "react";

export default function UnitLinks(props) {
  const [unit, setUnit] = useState("celsius");

  function displayFahrenheit(event) {
    event.preventDefault();
    setUnit("fahrenheit");
  }

  function displayCelsius(event) {
    event.preventDefault();
    setUnit("celsius");
  }

  if (unit === "celsius") {
    return (
      <div className="CurrentTemp">
        Current temperature: {props.celsius}
        <span id="conversion-links">
          <sup>
            <span className="active" id="celsius-link">
              °C
            </span>
            |
            <a href="/" id="farenheit-link" onClick={displayFahrenheit}>
              °F
            </a>
          </sup>
        </span>
      </div>
    );
  } else {
    let fahrenheitTemp = Math.round(props.celsius * 1.8 + 32);
    return (
      <div className="CurrentTemp">
        Current temperature: {fahrenheitTemp}
        <span id="conversion-links">
          <sup>
            <a href="/" id="celsius-link" onClick={displayCelsius}>
              °C
            </a>
            |
            <span className="active" id="farenheit-link">
              °F
            </span>
          </sup>
        </span>
      </div>
    );
  }
}
